import { pushToDatalayer } from "../utils/tracking/gtmTracking";

export const selectPlan = () => {
    try {
        const payload = {
            action: "RSR_Select Plan_Next",
            category: "Raise Service Request",
            page_name: "Plan Selection Page",
            field_name: "Select Plan - Click"
        }
        pushToDatalayer("RSR_Select Plan_Next", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const selectService = () => {
    try {
        const payload = {
            action: "RSR_Select Service_Next",
            category: "Raise Service Request",
            page_name: "Cover Selection Page",
            field_name: "Select Service - Click"
        }
        pushToDatalayer("RSR_Select Service_Next", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const selectIssues = () => {
    try {
        const payload = {
            action: "RSR_Select Issues_Next",
            category: "Raise Service Request",
            page_name: "Issue Selection Page",
            field_name: "Select Issues - Click"
        }
        pushToDatalayer("RSR_Select Issues_Next", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const enterAddress = () => {
    try {
        const payload = {
            action: "RSR_Address and Slot_Next",
            category: "Raise Service Request",
            page_name: "Address Page",
            field_name: "Enter Address - Submit"
        }
        pushToDatalayer("RSR_Address and Slot_Next", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const confirmDetails = () => {
    try {
        const payload = {
            action: "RSR_Details Confirmed",
            category: "Raise Service Request",
            page_name: "SR Creation",
            field_name: "Confirm Details - Button"
        }
        pushToDatalayer("RSR_Details Confirmed", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const makePayment = () => {
    try {
        const payload = {
            action: "RSR_Make Payment",
            category: "Raise Service Request",
            page_name: "Order Summary",
            field_name: "Make Payment - Button"
        }
        pushToDatalayer("RSR_Make Payment", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const successPage = () => {
    try {
        const payload = {
            action: "RSR_SR Successful",
            category: "Raise Service Request",
            page_name: "SR Creation Success Page",
            field_name: "SR Successful"
        }
        pushToDatalayer("RSR_SR Successful", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const failurePage = () => {
    try {
        const payload = {
            action: "RSR_SR Unsuccessful",
            category: "Raise Service Request",
            page_name: "SR Creation Failure Page",
            field_name: "SR Unsuccessful"
        }
        pushToDatalayer("RSR_SR Unsuccessful", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const planNotFoundPage = () => {
    try {
        const payload = {
            action: "RSR_No Plan Found Page",
            category: "Raise Service Request",
            page_name: "No Plan Found Page",
            field_name: "No Plan Found Page"
        }
        pushToDatalayer("RSR_No Plan Found Page", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const planNotFoundClick = () => {
    try {
        const payload = {
            action: "RSR_No Plan Found",
            category: "Raise Service Request",
            page_name: "No Plan Found",
            field_name: "No Plan Found"
        }
        pushToDatalayer("RSR_No Plan Found", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const planPageModal = (modalType, page) => {
    try {
        const event = "RSR_" + modalType + " Open";
        const payload = {
            action: "RSR_" + modalType + " Open",
            category: "Raise Service Request",
            page_name: page,
            field_name: modalType + " Open"
        }
        pushToDatalayer(event, payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const chatWithUsModal = (page) => {
    try {
        const payload = {
            action: "RSR_Chat With Us",
            category: "Raise Service Request",
            page_name: page,
            field_name: "Chat With Us Button"
        }
        pushToDatalayer("RSR_Chat With Us", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const raiseQueryClick = () => {
    try {
        const payload = {
            action: "RSR_Raise Query Button",
            category: "Raise Service Request",
            page_name: "Open SR Modal",
            field_name: "Raise Query Button - Click"
        }
        pushToDatalayer("RSR_Raise Query Button", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const raiseQuerySumbit = () => {
    try {
        const payload = {
            action: "RSR_Raise Query Submit",
            category: "Raise Service Request",
            page_name: "Open SR Modal",
            field_name: "Raise Query Submit - Click"
        }
        pushToDatalayer("RSR_Raise Query Submit", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const reopenSR = () => {
    try {
        const payload = {
            action: "RSR_Reopen SR",
            category: "Raise Service Request",
            page_name: "Reopen SR Modal",
            field_name: "Reopen SR - Click"
        }
        pushToDatalayer("RSR_Reopen SR", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const activatePlan = () => {
    try {
        const payload = {
            action: "RSR_Activate Plan",
            category: "Raise Service Request",
            page_name: "Activate Plan Modal",
            field_name: "Activate Plan Button"
        }
        pushToDatalayer("RSR_Activate Plan", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const trackSR = () => {
    try {
        const payload = {
            action: "RSR_Track SR",
            category: "Raise Service Request",
            page_name: "Plan Page",
            field_name: "Track Request"
        }
        pushToDatalayer("RSR_Track SR", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}

export const termsofServiceClicked = (page) => {
    try {
        const payload = {
            page_name: page,
        }
        pushToDatalayer("Terms of Service Clicked", payload)
    }
    catch {
        console.log('error while pushing to datalayer')
    }
}



